<script setup lang="ts">
    import { LazyOrgLanguageDrawer } from '#components';
    import 'flag-icons/css/flag-icons.min.css';

    const { isInternational, languageName, flag } = useLocales();

    const nuxtApp = useNuxtApp();

    interface LanguageButtonProps {
        theme?: 'navbar' | 'footer';
    }
    defineProps<LanguageButtonProps>();
    const { regionNamesInLocale, iso2Country } = useLocales();

    const openDrawer = () => {
        nuxtApp.$eventEmitter.emit('open-drawer', {
            title: '',
            content: {
                component: LazyOrgLanguageDrawer,
                props: {},
            },
        });
        return false;
    };
</script>
<template>
    <button
        :class="[
            'atm-language-button flex items-center gap-3 text-base transition-colors hover:text-woom-red max-lg:py-3',
            {
                'inline-flex h-10 w-10 cursor-pointer flex-row p-1 transition-opacity hover:opacity-100': theme === 'navbar',
                'p-2 max-lg:-ml-2': theme === 'footer',
            },
        ]"
        @click="openDrawer"
        :title="languageName"
        :aria-label="`${languageName} - ${$t('cta.openLanguageDrawer')}`">
        <span
            v-if="!isInternational"
            :class="['flag-icon !w-6', flag, { 'm-auto h-[19px] rounded-sm border border-solid border-woom-black bg-cover': theme === 'navbar' }]">
        </span>
        <woom-icon-world
            v-else
            :class="['h-6 w-6 fill-current', { 'm-auto': theme === 'navbar' }]" />
        <span
            v-if="theme !== 'navbar'"
            :class="{ 'font-mono text-xs': theme === 'footer' }">
            <template v-if="isInternational">Country/Language</template>
            <template v-else>{{ languageName }} / {{ regionNamesInLocale.of(iso2Country) }}</template>
        </span>
    </button>
</template>
